export default {
    methods: {
        initializeDateRangeArray(startDate, stopDate) {
            var dateArray = [];
            var currentDate = startDate;
            while (currentDate < stopDate) {
                dateArray.push(
                    new Date(currentDate).toISOString().split("T")[0]
                );
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return dateArray;
        },
    },
};
